import React from 'react'
import DraftBtn from './servicesButtons/DraftBtn';
import { useTranslate } from './TranslationText';
import SubmitServiceBtn from './servicesButtons/SubmitServiceBtn';
import Popup from 'reactjs-popup';
import { eFormButtonsContainer } from '../common/cssclasses';

export default function CustomSecondPopUp({
    trigger,
    children,
    onSave,
    onClear,
    onClose,
    btnText,
    isDisabled = false,
    title = "",
    ...props
}) {
    const { translate } = useTranslate();
    return (
        <Popup
            modal
            lockScroll
            trigger={trigger}
            closeOnDocumentClick={false}
            closeOnEscape

            overlayStyle={{ zIndex: 5000 }}
            contentStyle={{ maxWidth: '80%', minWidth: '300px' }}
            {...props}
        >
            {(close) => (
                <>
                    {!!title &&
                        < h4 className='fw-bold'>
                            {title}
                        </h4>
                    }
                    <div className="popUpElemnts mb-main">{children}</div>
                    <div className={eFormButtonsContainer}>
                        {!!onClear &&
                            <DraftBtn onClick={onClear} text={translate('web.clear', 'clear')} />
                        }
                        <DraftBtn onClick={() => { onClose?.(); close(); }} text={translate('web.close', 'Close')} />
                        {!!onSave &&
                            <SubmitServiceBtn disabled={isDisabled} text={btnText} onClick={() => { onSave?.(); close(); }} />
                        }
                    </div>
                </>
            )}
        </Popup>
    )
}
